import { render } from "./onchainatm.vue?vue&type=template&id=05b7fe76&scoped=true"
import script from "./onchainatm.vue?vue&type=script&lang=js"
export * from "./onchainatm.vue?vue&type=script&lang=js"

import "./onchainatm.vue?vue&type=style&index=0&id=05b7fe76&lang=css"
import "./onchainatm.vue?vue&type=style&index=1&id=05b7fe76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b7fe76"]])

export default __exports__